import { importWithRetry } from '@trello/use-lazy-component';

export const preloadBoardView = () =>
  importWithRetry(
    () =>
      import(
        /* webpackChunkName: "board-view" */ 'app/scripts/views/board/BoardView'
      ),
  );
